"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2ja9ykyfzs = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryFormMenu.js";
  var hash = "7bac504f76379c5669309bc2f7498591ec1bb9b4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryFormMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "1": {
        start: {
          line: 15,
          column: 39
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "2": {
        start: {
          line: 27,
          column: 18
        },
        end: {
          line: 27,
          column: 29
        }
      },
      "3": {
        start: {
          line: 28,
          column: 28
        },
        end: {
          line: 28,
          column: 43
        }
      },
      "4": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 33,
          column: 17
        }
      },
      "5": {
        start: {
          line: 31,
          column: 49
        },
        end: {
          line: 31,
          column: 64
        }
      },
      "6": {
        start: {
          line: 36,
          column: 23
        },
        end: {
          line: 36,
          column: 28
        }
      },
      "7": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "8": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "9": {
        start: {
          line: 40,
          column: 42
        },
        end: {
          line: 40,
          column: 58
        }
      },
      "10": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 53,
          column: 4
        }
      },
      "11": {
        start: {
          line: 56,
          column: 0
        },
        end: {
          line: 56,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 15,
            column: 30
          }
        },
        loc: {
          start: {
            line: 15,
            column: 39
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "RepositoryFormMenu",
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 27
          }
        },
        loc: {
          start: {
            line: 26,
            column: 30
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 41
          },
          end: {
            line: 31,
            column: 42
          }
        },
        loc: {
          start: {
            line: 31,
            column: 47
          },
          end: {
            line: 31,
            column: 66
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 34
          },
          end: {
            line: 40,
            column: 35
          }
        },
        loc: {
          start: {
            line: 40,
            column: 40
          },
          end: {
            line: 40,
            column: 60
          }
        },
        line: 40
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }, {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "7bac504f76379c5669309bc2f7498591ec1bb9b4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _ = require("./");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_2ja9ykyfzs.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_2ja9ykyfzs.f[0]++;
  cov_2ja9ykyfzs.s[1]++;
  return {
    modal: {
      position: 'absolute',
      top: '10%',
      left: '10%',
      right: '10%',
      maxHeight: '80%',
      overflow: 'scroll'
    }
  };
}));

function RepositoryFormMenu() {
  cov_2ja9ykyfzs.f[1]++;
  var classes = (cov_2ja9ykyfzs.s[2]++, useStyles());

  var _ref = (cov_2ja9ykyfzs.s[3]++, (0, _react.useState)(false)),
      _ref2 = _slicedToArray(_ref, 2),
      modal = _ref2[0],
      setModal = _ref2[1];

  var button = (cov_2ja9ykyfzs.s[4]++, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    onClick: function onClick() {
      cov_2ja9ykyfzs.f[2]++;
      cov_2ja9ykyfzs.s[5]++;
      setModal(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.FolderShared, null)));
  var modalComponent = (cov_2ja9ykyfzs.s[6]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  cov_2ja9ykyfzs.s[7]++;

  if (modal) {
    cov_2ja9ykyfzs.b[0][0]++;
    cov_2ja9ykyfzs.s[8]++;
    modalComponent = /*#__PURE__*/_react.default.createElement(_core.Modal, {
      open: true,
      onClose: function onClose() {
        cov_2ja9ykyfzs.f[3]++;
        cov_2ja9ykyfzs.s[9]++;
        setModal(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: classes.modal
    }, /*#__PURE__*/_react.default.createElement(_.RepositoryForm, null)));
  } else {
    cov_2ja9ykyfzs.b[0][1]++;
  }

  cov_2ja9ykyfzs.s[10]++;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, button, modalComponent);
}

;
cov_2ja9ykyfzs.s[11]++;
RepositoryFormMenu.propTypes = {};
var _default = RepositoryFormMenu;
exports.default = _default;